// src/plugins/axios.js
import axios from "axios";
import { API_URL } from "../Config/global";
import { useAuthStore } from "../Store/auth";
import pinia from "./pinia";

const api = axios.create({
    baseURL: API_URL,
    headers: {
        "Content-Type": "application/json",
        Accept: "application/json",
    },
});

const authStore = useAuthStore(pinia);

// Auto attach token if exists
api.interceptors.request.use((config) => {
    const token = authStore.token ?? false;
    if (token) {
        config.headers.Authorization = `Bearer ${token}`;
    }
    return config;
});

api.interceptors.response.use(
    (response) => response,
    (error) => {
        if (error.response?.status === 401) {
            authStore.logout();
            window.location.href = "/choose-role";
        }

        if (error.response?.status === 422) {
            return Promise.reject({
                type: "validation",
                errors: error.response.data.errors || {},
                message: error.response.data.message || "Validation failed",
            });
        }

        return Promise.reject(error);
    }
);

export default api;
